import styled from 'styled-components'

export const StyledMyPageSpecsBasketsGrid = styled.div`
  .basketLink {
    font-size: 14px;
  }
`
